import React from "react";
import { Route, Routes } from "react-router-dom";
import AcademicCalendarView from "../../views/academicCalendar/AcademicCalendarView";
import { Box } from "@mui/material";
const TutorRouter = () => {
  return (
    <Routes>
      <Route path="academic-calendar/*" element={
        <>
        <Box p={2}>
          <AcademicCalendarView  publicRoute={true} />
        </Box>
        </>
      } />
    </Routes>
  );
};

export default TutorRouter;
